import { ChainId } from 'types';

import { envVariables } from './envVariables';

const bittensorTestnetPrivateSubtensorWsUrl =
  envVariables.VITE_BITTENSOR_TESTNET_SUBTENSOR_WS_URL?.trim();

const bittensorTestnetPublicSubtensorWsUrl = 'wss://test.finney.opentensor.ai:443';

export const subtensorWsUrls: Partial<Record<ChainId, string>> = {
  [ChainId.BITTENSOR_TESTNET]:
    bittensorTestnetPrivateSubtensorWsUrl || bittensorTestnetPublicSubtensorWsUrl,
};
